// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Prevent scrolling when sidebar is open */
body.no-scroll {
  overflow: hidden;
}
.scrollbar {
  height: 100vh;
}

header {
  position: fixed;
  top: 0;
  width: 100%;
  /* z-index: 9999; */
  margin-bottom: 100px;
}
.fixed-navbar-icon {
  position: fixed;
  top: 1rem; /* Adjust this value as needed */
  left: 1rem; /* Or right: 1rem if you want it on the right */
  z-index: 1000; /* Ensure it's above all other content */
  cursor: pointer;
}

/* Sidebar Container */
.scrollbar {
  overflow-y: auto;
  background-color: #2865aa;
  position: absolute; /* For mobile: position absolute to slide in/out */
  height: 100%;
  width: 250px;
  transition: transform 0.3s ease-in-out;
  z-index: 1100; /* Sidebar stays on top */
}

/* Sidebar Open & Close */
.scrollbar.open {
  transform: translateX(0);
}

.scrollbar.closed {
  transform: translateX(-100%);
}

/* Sidebar Content */
.sidebar-content {
  padding: 20px;
  color: white;
}

/* Logo */
.logo-container {
  text-align: center;
  margin-bottom: 20px;
}

.logo {
  width: 100px;
  height: auto;
}

/* Menu Items */
.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-list li {
  padding: 10px 15px;
  transition: background 0.3s ease;
}

.menu-list li a {
  color: white;
  text-decoration: none;
  font-size: 14px;
  font-weight: bold;
  display: block;
}

.menu-list li:hover {
  background-color: #5390d9;
}

.dropdown-btn {
  background: none;
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  text-align: left;
  padding: 10px 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dropdown-btn:hover {
  background-color: #5390d9;
}

.dropdown-container {
  display: none;
  padding-left: 15px;
  background-color: #1e4f8c;
}

.dropdown-container a {
  color: white;
  padding: 8px 0;
  display: block;
  font-weight: 400; /* Normal text for submenu */
  font-size: 14px;
}

/* Social Media Icons */
.social-media {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.social-media a {
  margin: 0 5px;
}

.social-media img {
  width: 24px;
  height: 24px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

/* Responsive Design */
@media (min-width: 768px) {
  /* Sidebar for Desktop: Keep it fixed */
  .scrollbar {
    position: fixed;
    top: 0;
    left: 0;
    transform: translateX(0);
    height: 100%;
  }

  /* Sidebar Toggle for Desktop: Remove for larger screens */
  .sidebar-toggle {
    display: none;
  }

  .dropdown-container {
    display: none;
    padding-left: 15px;
    background-color: #1e4f8c;
  }

  .dropdown-container a {
    color: white;
    padding: 8px 0;
    display: block;
    font-weight: 400; /* Normal weight for submenu */
  }
}

@media (max-width: 767px) {
  /* For Mobile View: Set sidebar height to 100vh */
  .scrollbar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh; /* Full screen height */
    position: fixed;
    left: -250px; /* Hidden by default */
  }

  .overlay {
    display: block;
  }
  .scrollbar.open {
    left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,SAAS,EAAE,gCAAgC;EAC3C,UAAU,EAAE,+CAA+C;EAC3D,aAAa,EAAE,wCAAwC;EACvD,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB,EAAE,kDAAkD;EACtE,YAAY;EACZ,YAAY;EACZ,sCAAsC;EACtC,aAAa,EAAE,yBAAyB;AAC1C;;AAEA,yBAAyB;AACzB;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,YAAY;AACd;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB,EAAE,4BAA4B;EAC9C,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,uCAAuC;EACvC;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB,YAAY;EACd;;EAEA,0DAA0D;EAC1D;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,cAAc;IACd,gBAAgB,EAAE,8BAA8B;EAClD;AACF;;AAEA;EACE,iDAAiD;EACjD;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa,EAAE,uBAAuB;IACtC,eAAe;IACf,YAAY,EAAE,sBAAsB;EACtC;;EAEA;IACE,cAAc;EAChB;EACA;IACE,OAAO;EACT;AACF","sourcesContent":["/* Prevent scrolling when sidebar is open */\nbody.no-scroll {\n  overflow: hidden;\n}\n.scrollbar {\n  height: 100vh;\n}\n\nheader {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  /* z-index: 9999; */\n  margin-bottom: 100px;\n}\n.fixed-navbar-icon {\n  position: fixed;\n  top: 1rem; /* Adjust this value as needed */\n  left: 1rem; /* Or right: 1rem if you want it on the right */\n  z-index: 1000; /* Ensure it's above all other content */\n  cursor: pointer;\n}\n\n/* Sidebar Container */\n.scrollbar {\n  overflow-y: auto;\n  background-color: #2865aa;\n  position: absolute; /* For mobile: position absolute to slide in/out */\n  height: 100%;\n  width: 250px;\n  transition: transform 0.3s ease-in-out;\n  z-index: 1100; /* Sidebar stays on top */\n}\n\n/* Sidebar Open & Close */\n.scrollbar.open {\n  transform: translateX(0);\n}\n\n.scrollbar.closed {\n  transform: translateX(-100%);\n}\n\n/* Sidebar Content */\n.sidebar-content {\n  padding: 20px;\n  color: white;\n}\n\n/* Logo */\n.logo-container {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.logo {\n  width: 100px;\n  height: auto;\n}\n\n/* Menu Items */\n.menu-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.menu-list li {\n  padding: 10px 15px;\n  transition: background 0.3s ease;\n}\n\n.menu-list li a {\n  color: white;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: bold;\n  display: block;\n}\n\n.menu-list li:hover {\n  background-color: #5390d9;\n}\n\n.dropdown-btn {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  width: 100%;\n  text-align: left;\n  padding: 10px 15px;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dropdown-btn:hover {\n  background-color: #5390d9;\n}\n\n.dropdown-container {\n  display: none;\n  padding-left: 15px;\n  background-color: #1e4f8c;\n}\n\n.dropdown-container a {\n  color: white;\n  padding: 8px 0;\n  display: block;\n  font-weight: 400; /* Normal text for submenu */\n  font-size: 14px;\n}\n\n/* Social Media Icons */\n.social-media {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.social-media a {\n  margin: 0 5px;\n}\n\n.social-media img {\n  width: 24px;\n  height: 24px;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  /* Sidebar for Desktop: Keep it fixed */\n  .scrollbar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    transform: translateX(0);\n    height: 100%;\n  }\n\n  /* Sidebar Toggle for Desktop: Remove for larger screens */\n  .sidebar-toggle {\n    display: none;\n  }\n\n  .dropdown-container {\n    display: none;\n    padding-left: 15px;\n    background-color: #1e4f8c;\n  }\n\n  .dropdown-container a {\n    color: white;\n    padding: 8px 0;\n    display: block;\n    font-weight: 400; /* Normal weight for submenu */\n  }\n}\n\n@media (max-width: 767px) {\n  /* For Mobile View: Set sidebar height to 100vh */\n  .scrollbar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100vh; /* Full screen height */\n    position: fixed;\n    left: -250px; /* Hidden by default */\n  }\n\n  .overlay {\n    display: block;\n  }\n  .scrollbar.open {\n    left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
